import React from 'react';
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import OpsText from "./ops-text";
import formatDate from "../functions/formatDate";
import {FaRegStopCircle, FaSortDown} from "react-icons/fa";
import OpsBtn from "./ops-btn";
import {TbRestore} from "react-icons/tb";
import {BiShow, BiSolidEdit} from "react-icons/bi";
import OpsIconStatus from "./ops-icon-status";
import OpsAvatar from "./ops-avatar";
import {LoadingSpinner} from "../components/LoadingSpinner";
import {opsConfirmDialog} from "./ops-confirm-dialog";
import {datetime} from "react-table/src/sortTypes";
import {FaTrashCan} from "react-icons/fa6";

const OpsTable = ({
                      name = "Tabuľka",
                      data = [],
                      id,
                      theme,
                      columns,
                      classname,
                  }) => {

    const tableData = {
        columns,
        data
    };

    return (
        data !== null && columns !== null ?
            <DataTableExtensions {...tableData} export={false} print={false} filterPlaceholder={"Vyhľadať v tabuľke"}>
                <DataTable
                    className="custom-table"
                    columns={columns}
                    data={data}
                    sortIcon={<FaSortDown/>}
                    defaultSortAsc={true}
                    pagination
                    paginationPerPage={30}
                    paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                    // highlightOnHover
                    // dense
                    noDataComponent="Načitávanie záznamov..."
                />
            </DataTableExtensions>
            :
            <div className="fa-w-100 my-5">
                <LoadingSpinner/>
            </div>
    );
};

export default OpsTable;